import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  IconButton,
  Typography,
  withStyles,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useDispatch } from 'src/store';
import useAuth from 'src/hooks/useAuth';
import { logout } from 'src/slices/auth';

const styles = (theme) => ({
  root: {
    position: 'relative',
    margin: 0,
    padding: theme.spacing(2),
    textAlign: 'center',
    textTransform: 'capitalize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Box mr={1} />
      <Typography variant="h5">{children}</Typography>
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles({
  paper: { width: 400 },
  dialogAction: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 5
  }
});

const ConfirmLogout = ({ confirmPop, setConfirmPop }) => {
  const history = useHistory();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const classes = useStyles();
  const handleClose = () => {
    setConfirmPop(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());
      history.push('/');
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      open={confirmPop}
      scroll="body"
      classes={{
        paper: classes.paper
      }}
      maxWidth="lg"
    >
      <DialogTitle onClose={handleClose}>Confirm Logout</DialogTitle>
      <DialogContent dividers>
        You're currently logged in to your account as
        <strong> {user.userEmail}</strong>. Are you sure you want to logout of
        this account?
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button color="secondary" variant="outlined" onClick={handleLogout}>
          Yes, i do
        </Button>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          No, i don't
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmLogout;
